import template from './rooms-for-rent-count.jade';

export default angular
  .module('cian.addForm.roomsForRentCount', [])
  .directive('cianAfAboutObjectRoomsForRentCount', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [function () {}],
    controllerAs: 'roomsForRentCount',
    template,
  })).name;
